@let isPdfMode = pdfMode();
@let isIOsMode = iOsMode();

<div [class.pdf-mode]="isPdfMode">
  <div class="header">
    <div class="data-type">{{ getTranslationKeyByKey(rootTranslationKey()) }}
    </div>
    <div class="column current-column"
         [class.pension-info-column]="isPensionInfoData()">{{ getTranslationKeyByKey('is') }}
    </div>
    <div class="column new-column"
         [class.pension-info-column]="isPensionInfoData()">{{ getTranslationKeyByKey('new') }}
    </div>
    @if (isPensionInfoData()) {
      <div class="column other-column"
           [class.pension-info-column]="isPensionInfoData()">{{ getTranslationKeyByKey('diff') }}
      </div>
    } @else {
      <div class="column other-column percentage-column">{{ Constants.PERCENT }}</div>
      <div class="column other-column chf-column">{{ Constants.CHF }}</div>
    }
  </div>
  @for (key of getDataKeys(); track $index) {
    <div class="row" [class.pdf-mode]="isPdfMode">
      <div class="data-type">
        <span>{{ getTranslationTitle(key) }}</span>
        @if (getTranslationForRemark(key)) {
          <div class="icon-wrapper">
            @if (isMobileView() && !isIOsMode) {
              <div>
                <img src="assets/icons/status-info_bg.svg"
                     (click)="openBottomSheet(getTranslationTitle(key), getTranslationForRemark(key))">
              </div>
            } @else {
              @if (!isIOsMode) {
                <img src="assets/icons/status-info_bg.svg"
                     [matTooltip]="getTranslationForRemark(key)">
              }
            }
          </div>
        }
      </div>
      @if (isPensionInfoData()) {
        <div class="cell pension-info-cell">{{ getTranslationValue(getStringValues(key).current) }}</div>
        <div class="cell pension-info-cell">{{ getTranslationValue(getStringValues(key).offer) }}</div>
      } @else {
        @if (isEmployeeContributionsPctData(key)) {
          <div class="cell">{{ getNumericValue(key).current | roundPercentage }}
          </div>
          <div class="cell">{{ getNumericValue(key).offer | roundPercentage }}
          </div>
        } @else if (isCostsAndFinancingData()) {
          <div class="cell">
            <span
              class="currency">{{ Constants.CHF }}</span>{{ getNumericValue(key).current | pasteApostropheWithFixedDecimals }}
          </div>
          <div class="cell"><span
            class="currency">{{ Constants.CHF }}</span>{{ getNumericValue(key).offer | pasteApostropheWithFixedDecimals }}
          </div>
        } @else {
          <div class="cell">
            <span
              class="currency">{{ Constants.CHF }}</span>{{ getNumericValue(key).current | pasteApostropheAfterEachThreeNums }}
          </div>
          <div class="cell"><span
            class="currency">{{ Constants.CHF }}</span>{{ getNumericValue(key).offer | pasteApostropheAfterEachThreeNums }}
          </div>
        }
      }
      @if (isPensionInfoData()) {
        <div class="cell other-cell"
             [class.pension-info-cell]="isPensionInfoData()">{{ getDifferenceLabel(getStringValues(key)) }}
        </div>
      } @else {
        <div class="cell other-cell percentage-cell">{{ getNumericValue(key).percent | roundPercentage }}</div>
        <div class="cell other-cell chf-cell">
          @if (isEmployeeContributionsPctData(key)) {
            {{ getNumericValue(key).difference  | roundPercentage }}
          } @else if (isCostsAndFinancingData()) {
            <span
              class="currency">{{ Constants.CHF }}</span>{{ getNumericValue(key).difference | pasteApostropheWithFixedDecimals }}
          } @else {
            <span
              class="currency">{{ Constants.CHF }}</span>{{ getNumericValue(key).difference | pasteApostropheAfterEachThreeNums }}
          }
        </div>
      }
    </div>
  }
</div>
<div class="pb-xl"></div>
